import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'slotStatusPipe'
})
export class SlotStatusPipe implements PipeTransform {
  private listObj: any = {
    0: 'Pending Booking',
    1: 'Booked',
    2: 'Booking Approved',
    3: 'Completed',
  };


  transform(value: number): string {
    return this.listObj.hasOwnProperty(value) ? this.listObj[value] : '';
  }

}
